import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Alert from '../../../Alert/Alert';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTCLI_Challenge_Questions,
  TXTWCL_If_you_forget_your_passwordX_y_ELL,
  TXTWCL_The_answers_should_be_unique_a_ELL,
  TXTWCL_Think_of_answers_that_are_memo_ELL,
  TXTWCL_Which_challenge_questions_do_y_ELL
} from './RMFSecurityQuestions.messages.json';
import { info } from './RMFSecurityQuestions.scss';
import SecurityQuestionsFields from './components/SecurityQuestionsFields';

const RMFSecurityQuestions: React.FC = () => (
  <Container
    page={RMFSecurityQuestions}
    headerProps={{
      title: <Translation {...TXTCLI_Challenge_Questions} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Which_challenge_questions_do_y_ELL} />}
    pageTopSubtitle={<Translation {...TXTWCL_If_you_forget_your_passwordX_y_ELL} />}
  >
    <Alert variant="info" className={info}>
      <>
        <Translation {...TXTWCL_Think_of_answers_that_are_memo_ELL} />{' '}
        <Translation {...TXTWCL_The_answers_should_be_unique_a_ELL} />
      </>
    </Alert>
    <SecurityQuestionsFields />
    <CTAButton />
  </Container>
);

RMFSecurityQuestions.displayName = 'RMFSecurityQuestions';

export default RMFSecurityQuestions;
